var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDescendingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 5,
    viewBox: "0 0 12 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.619 8.32941e-07C11.0866 8.73824e-07 11.2983 0.58473 10.9391 0.884112L6.32009 4.73326C6.13467 4.88778 5.86533 4.88778 5.67991 4.73326L1.06093 0.884112C0.701677 0.58473 0.913377 -1.55491e-08 1.38103 2.53341e-08L6 4.29138e-07L10.619 8.32941e-07Z",
    fill: "#148BCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDescendingActive);
export default __webpack_public_path__ + "static/media/order_descending_active.1fdb6cb0f1abf7227948f5a8b7b7fa80.svg";
export { ForwardRef as ReactComponent };